const Config: Record<ConfigKey, string | boolean> = {
  WALLET_HOST: process.env.REACT_APP_WALLET_HOST || '',
  CHECKOUT_SECURITY_HOST: process.env.REACT_APP_CHECKOUT_SECURITY_HOST || '',
  ENV: process.env.REACT_APP_ENV || 'development',
  URL: process.env.REACT_APP_URL ?? '',
};

export default Config;
